import React, { useState } from "react";

import { Layout } from "antd";
import MobileHeader from "./MobileHeader";
import MobileSiderMenu from "../sider/MobileSiderMenu";
import { Outlet } from "react-router";

const MobileLayout = () => {
  const [open, setOpen] = useState(false);

  return (
    <Layout className="relative overflow-x-hidden h-screen">
      <Layout>
        <MobileHeader setOpen={setOpen} open={open} />

        <Outlet />
      </Layout>
      <MobileSiderMenu open={open} setOpen={setOpen} />
    </Layout>
  );
};

export default MobileLayout;
